import script from "./languageButtonStandalonePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./languageButtonStandalonePage.vue?vue&type=script&setup=true&lang=ts"

import "./languageButtonStandalonePage.vue?vue&type=style&index=0&id=19a10a6d&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19a10a6d"]])

export default __exports__